<!-- eslint-disable max-len -->
<template>
  <div v-if="loading" class="loadingContainer">
    <Loader isLoading />
  </div>
  <div v-else class="container-contract fade-in">
    <header class="header-container">
      <h1 class="title">Termos e Condições de Uso do Super Limite Ame</h1>
    </header>
    <main class="main-container">
      <p>
        Estes Termos e Condições de Uso (“<span style="text-decoration: underline;">Termos de
        Uso</span>”) regem o acesso dos usuários da plataforma da Ame
        Digital (“<span style="text-decoration: underline;">Usuário</span>” e “<span style="text-decoration: underline;">Plataforma Ame</span>”) ao
        Super Limite Ame, benefício que tem como objetivo viabilizar o
        parcelamento de compras nos Estabelecimentos Conveniados, conforme
        definido a seguir, facilitando a organização financeira
        dos Usuários (“<span style="text-decoration: underline;">Super Limite Ame</span>”).
      </p>
      <p>
        A Plataforma Ame é disponibilizada pela <span style="font-weight: 700;">AME DIGITAL BRASIL
        INSTITUIÇÃO DE PAGAMENTO LTDA.,</span> sociedade
        empresária limitada, inscrita no CNPJ/MF sob o nº
        32.778.350/0001-70, com sede na cidade de São Paulo, Estado de
        São Paulo, na Rua Fidêncio Ramos, nº 302, Torre B,
        1º andar, Vila Olímpia, CEP 04551-010, neste ato devidamente
        representada nos termos do seu contrato social
        (“<span style="text-decoration: underline;">Ame</span>”).
      </p>
      <p>
        Ao optar por utilizar o Super Limite Ame, o parcelamento das compras do
        Usuário é viabilizado pela <span style="font-weight: 700;">PARCELEX CORRESPONDENTE
        BANCÁRIO S.A.,</span> sociedade por ações de capital
        fechado, inscrita no CNPJ/MF sob o nº 14.054.623/0001-51, com sede
        na Rua Voluntários da Pátria, n° 89, sala 701,
        Botafogo, CEP 22270-000, Cidade do Rio de Janeiro, Estado do Rio de
        Janeiro (“<span style="text-decoration: underline;">Parcelex</span>”).
      </p>
      <p>
        Como condição para a utilização do Super
        Limite Ame, o Usuário deve declarar que fez a leitura completa e
        atenta das regras dos Termos de Uso, estando plenamente ciente e de
        acordo com ele.
      </p>
      <h2 style="font-weight: 700; font-size: 16px;">1. OBJETO</h2>
      <p>
        A Ame colocará à disposição do
        Usuário o Super Limite Ame, solução de pagamento
        que permite o parcelamento de valores devidos a Estabelecimentos
        Conveniados na aquisição de produtos
        (“<span style="text-decoration: underline;">Produtos</span>”).
      </p>

      <p>
        Os presentes Termos de Uso não eximem o Usuário da leitura
        completa e atenta de eventuais condições de uso
        aplicáveis aos Usuários por força de seu
        vínculo com a Ame ou com a Parcelex, ou quaisquer outras
        condições e regras operacionais e de segurança a
        serem instituídas pela Parcelex, pela Instituição
        Financeira, conforme definida abaixo, e/ou pelo Banco Central do Brasil,
        devendo observá-las e respeitá-las integralmente.
      </p>
      <p>
        O Usuário está ciente de que a Parcelex atua como mera
        intermediadora de pagamentos entre a Instituição
        Financeira, a Ame e os Usuários, não sendo a Parcelex uma
        instituição financeira ou prestadora de serviços
        financeiros.
      </p>
      <p>
        Ao anuir a estes Termos de Uso, o Usuário declara que fez a
        leitura atenta dos Termos e Condições de Uso da Plataforma
        da Parcelex (disponível em:
        <a
          data-fr-linked="true"
          href="https://www.parcelex.com.br/termos-de-uso"
          >https://www.parcelex.com.br/termos-de-uso</a
        >), os quais, no que aplicável, devem ser observados na
        utilização do Super Limite Ame.
      </p>

      <p>
        Caso haja indício de ilicitude, fraude ou violação
        aos Termos de Uso por parte do Usuário, o acesso do
        Usuário ao Super Limite Ame poderá ser suspenso ou
        interrompido pela Parcelex ou pela Ame, a seu exclusivo critério.
      </p>

      <h2 style="font-weight: 700; font-size: 16px;">2. DOS ESTABELECIMENTOS CONVENIADOS </h2>

      <p>
        O Super Limite Ame será disponibilizado para compras realizadas
        por meio da Plataforma Ame em unidades das lojas da Americanas S.A. que
        estejam habilitadas para recebimento via Super Limite Ame
        (“<span style="text-decoration: underline;">Transações</span>” e “<span style="text-decoration: underline;">Estabelecimentos</span>
        Conveniados”).
      </p>

      <h2 style="font-weight: 700; font-size: 16px;">3. DA UTILIZAÇÃO NOS ESTABELECIMENTOS CONVENIADOS</h2>

      <p>
        O Super Limite Ame é ofertado aos Usuários, por meio da
        Plataforma Ame, no momento em que o Usuário tem acesso a
        prévia do valor de crédito disponibilizado (“<span style="text-decoration: underline;">Valor
        Disponibilizado</span>”). Antes do efetivo aceite dos Termos de Uso pelo
        Usuário, a Parcelex e a Ame poderão alterar o valor ou
        retirar a oferta, a seu critério.
      </p>
      <p>
        Após o aceite dos Termos de Uso, o Valor Disponibilizado
        poderá ser utilizado pelo Usuário para
        realização de Transações em Estabelecimentos
        Conveniados pelo prazo máximo de 60 (sessenta) dias, sendo certo
        que a Parcelex poderá alterar o Valor Disponibilizado a seu
        exclusivo critério em qualquer momento, hipótese em que o
        Usuário será informado por meio da Plataforma Ame.
      </p>

      <p>
        No momento da compra, o Usuário poderá optar por utilizar
        parte ou a totalidade do saldo de seu Super Limite Ame diretamente pela
        Plataforma Ame. Uma vez selecionado o Super Limite Ame, o Usuário
        será submetido à verificação de identidade,
        conforme item 4 abaixo, e terá acesso às
        condições de pagamento de sua compra, tais como o
        número e o valor das parcelas, taxas de juros e tarifas
        eventualmente aplicáveis, dentre outras
        (“<span style="text-decoration: underline;">Condições Específicas</span>”). Será
        facultado ao Usuário aceitar ou rejeitar as
        Condições Específicas. Caso não esteja de
        acordo com as Condições Específicas apresentadas, o
        Usuário deverá utilizar outra forma de pagamento para
        realizar sua compra.
      </p>

      <h2 style="font-weight: 700; font-size: 16px;">4. VERIFICAÇÃO DE IDENTIDADE PELA PARCELEX</h2>

      <p>
        A fim de garantir que o Super Limite Ame não seja utilizado em
        operações fraudulentas, os Usuários deverão,
        sempre que solicitado pela Parcelex, realizar verificação
        biométrica, que exigirá o acesso à câmera do
        celular do Usuário. Após a autenticação
        biométrica, será necessário realizar a
        autenticação por meio de código enviado via SMS a
        cada Transação. Apenas após tais
        autenticações o Valor Disponibilizado poderá ser
        utilizado na Transação.
      </p>

      <p>
        O Usuário está ciente de que, caso não seja
        possível realizar a autenticação pessoal no momento
        da realização da compra, independentemente de ser o motivo
        imputável ao Usuário, à Plataforma Ame, à
        Parcelex, ou por motivos alheios às partes, ou, ainda, caso seja
        verificada inconsistência na validação que possa
        suscitar o risco de fraude, a utilização do Super Limite
        Ame será negada, sendo necessário que o Usuário
        opte por outra forma de pagamento para finalizar a compra. Nesta
        hipótese, não será devida qualquer
        indenização pela Parcelex ou pela Ame.
      </p>

      <p>
        Ao anuir aos Termos de Uso, o Usuário declara e garante que as
        informações fornecidas por si por meio da Plataforma Ame
        são verdadeiras, completas e precisas em todos os aspectos, bem
        como que os documentos digitalizados disponibilizados são
        cópias fiéis e integrais dos documentos originais em seu
        poder. O Usuário se responsabiliza por atualizar as
        informações fornecidas imediatamente caso qualquer delas
        seja alterada.
      </p>

      <h2 style="font-weight: 700; font-size: 16px;">5. DO PAGAMENTO DAS TRANSAÇÕES </h2>

      <p>
        O pagamento de Produtos por meio do Super Limite Ame será
        realizado pelos Usuários mediante a contratação de
        uma Cédula de Crédito Bancário a ser emitida pelo
        Usuário em favor da instituição financeira parceira
        da Parcelex (“<span style="text-decoration: underline;">Instituição Financeira</span>”).
      </p>

      <p>
        Uma vez realizada a opção do Usuário pelo uso do
        Super Limite Ame em determinada Transação, o valor da
        Transação será deduzido do Valor Disponibilizado,
        sendo facultado ao Usuário realizar novas
        Transações, desde que, de forma agregada, não
        ultrapasse o Valor Disponibilizado.
      </p>

      <p>
        O Usuário poderá acompanhar o extrato das
        Transações e das parcelas pendentes por meio da Plataforma
        Ame. Em dia do mês previamente selecionado pelo Usuário
        (“<span style="text-decoration: underline;">Data de Pagamento</span>”), estará disponível na
        Plataforma Ame o boleto bancário e/ou código Pix para
        quitação do valor devido pelo Usuário pela
        utilização do Super Limite Ame , de todas as parcelas
        vencidas no mês em questão, que podem corresponder a uma ou
        mais Transações, serão reunidas em boleto ou
        código Pix único para pagamento pelo Usuário na
        Data de Pagamento.
      </p>

      <h2 style="font-weight: 700; font-size: 16px;">6. ACESSO AOS SERVIÇOS PARCELEX</h2>

      <p>
        A Parcelex não se responsabiliza por qualquer dano direto ou
        indireto ocasionado por eventos de terceiros, como ataque de hackers,
        falhas no sistema, no servidor ou na conexão à internet,
        inclusive por ações de softwares maliciosos como
        vírus, cavalos de Tróia, e outros que possam, de algum
        modo, impedir a realização de Transações, ou
        a utilização e a navegação de seu sistema.
      </p>

      <p>
        A Parcelex envida seus melhores esforços para a disponibilidade
        contínua e permanente de seus serviços. No entanto, pode
        ocorrer, eventualmente, alguma indisponibilidade temporária
        decorrente de manutenção necessária ou mesmo gerada
        por motivo de força maior, como desastres naturais, falhas ou
        colapsos nos sistemas centrais de comunicação e acesso
        à Internet ou fatos de terceiro que fogem de sua esfera de
        vigilância e responsabilidade.
      </p>

      <p>
        Se isso ocorrer, a Parcelex fará o que estiver ao seu alcance
        para restabelecer o acesso a seus, dentro das limitações
        técnicas de seus serviços e serviços de terceiros.
      </p>

      <p>
        O Usuário, neste ato, renuncia a qualquer direito de pleitear
        indenização ou reparação de danos em caso de
        os serviços da Parcelex permanecerem fora do ar, impedindo a
        realização das Transações, independente da
        motivação ou de aviso prévio.
      </p>

      <h2 style="font-weight: 700; font-size: 16px;">7. DO ATRASO NO PAGAMENTO </h2>

      <p>
        É responsabilidade do Usuário estar ciente da Data de
        Pagamento e monitorar, via Plataforma Ame, os valores devidos pelo uso
        do Super Limite Ame. Não havendo quitação dos
        valores na Data de Pagamento, a Ame e a Parcelex poderão
        interromper imediatamente a oferta do Valor Disponibilizado, sem
        necessidade de aviso prévio ao Usuário.
      </p>

      <p>
        O atraso no pagamento das parcelas devidas ensejará a
        aplicação de eventuais penalidades descritas nas
        Condições Específicas de cada
        Transação e pode gerar, a critério da Parcelex e da
        Ame, o cancelamento do Super Limite Ame do Usuário, inclusive
        sendo inviabilizado o uso do Valor Disponível restante.
      </p>

      <p>
        O Usuário está ciente de que eventual inadimplemento
        poderá gerar sua inscrição em órgãos
        de proteção ao crédito, tais como, mas não
        se limitando, ao Serasa e ao Serviço de Proteção ao
        Crédito (SPC).
      </p>

      <h2 style="font-weight: 700; font-size: 16px;">8. DOS ESTORNOS E CANCELAMENTOS</h2>

      <p>
        O Usuário se declara ciente de que eventual descontentamento com
        os Produtos ou pretensão de estorno, independentemente do motivo,
        obedecerá exclusivamente às regras do Estabelecimento
        Conveniado em que foi realizada a Transação.
      </p>

      <p>
        Caberá ao Usuário informar à Ame por meio
        Plataforma Ame do estorno ou cancelamento, conforme estabelecido nos
        Termos e Condições de Uso da Ame, sendo certo que a
        cobrança dos valores devidos apenas será interrompida
        após a confirmação e anuência do
        Estabelecimento Conveniado. O valor eventualmente estornado em favor do
        Usuário corresponderá ao valor nominal da
        Transação, não havendo restituição de
        juros, tarifas ou eventuais penalidades aplicadas.
      </p>

      <h2 style="font-weight: 700; font-size: 16px;">9. DO USO DOS DADOS PESSOAIS </h2>

      <p>
        A Parcelex e a Ame tratarão os dados pessoais disponibilizados
        pelo Usuário em estrita conformidade com a Lei Federal nº
        13.709/2018 (Lei Geral de Proteção de Dados Pessoais
        – “<span style="text-decoration: underline;">LGPD</span>”) e em conformidade com as suas respectivas
        políticas de privacidade, disponíveis em https://www.parcelex.com.br/privacidade
        e https://www.amedigital.com/politica-de-privacidade.
      </p>

      <p>
        O Usuário, neste ato, concorda que a Instituição
        Financeira ou bureaus de crédito contratados pela Parcelex
        consultem, a qualquer momento, suas informações no Sistema
        de Informações de Crédito do Banco Central do
        Brasil (SCR), nos termos da Resolução nº 4.571, de 26
        de maio de 2017, do Conselho Monetário Nacional (CMN).
      </p>

      <p>
        O Usuário está ciente de que a Parcelex poderá
        compartilhar seus dados pessoais com agentes de cobrança
        subcontratados, que os utilizarão com o estrito fim de
        desincentivar a inadimplência e garantir o pagamento das parcelas
        vencidas.
      </p>

      <h2 style="font-weight: 700; font-size: 16px;">10. COMUNICAÇÃO</h2>

      <p>
        A comunicação entre o Usuário e a Ame e entre o
        Usuário e a Parcelex será realizada pelas ferramentas
        disponíveis na Plataforma Ame. O Usuário terá
        acesso direto à Parcelex pelos canais de atendimento, por e-mail
        e por WhatsApp, que podem ser encontrados no site em
        <a data-fr-linked="true" href="//www.parcelex.com.br"
          >www.parcelex.com.br</a
        >.
      </p>

      <p>
        O Usuário está ciente de que receberá, por meio das
        informações de contato disponibilizadas por si à
        Plataforma Ame, informes periódicos acerca de ofertas para uso do
        Super Limite Ame, bem como alertas de vencimento das parcelas pendentes
        e/ou notificações de cobrança, que podem ser
        encaminhados pela Ame, pela Parcelex ou por agentes de cobrança
        subcontratados.
      </p>

      <h2 style="font-weight: 700; font-size: 16px;">11. DISPOSIÇÕES GERAIS</h2>

      <p>
        A Parcelex e a Ame se reservam ao direito de alterar estes Termos de Uso
        e demais regras e critérios estabelecidos, não cabendo
        nenhum aviso prévio ao Usuário.
      </p>

      <p>
        Caso alguma disposição destes Termos de Uso seja julgada
        inaplicável ou sem efeito, o restante do documento continua a
        viger, sem a necessidade de medida judicial que declare tal assertiva.
      </p>

      <p>
        Os Termos de Uso aqui descritos são interpretados segundo a
        legislação brasileira, no idioma português, sendo
        eleito o Foro Central da Comarca do Rio de Janeiro/RJ para dirimir
        qualquer litígio ou controvérsia envolvendo o presente
        documento, salvo ressalva específica de competência
        pessoal, territorial ou funcional pela legislação
        aplicável.
      </p>

    </main>
    <div class="button-container">
      <Button
        :disabled="sending"
        theme="ame"
        class="button"
        @click="goToContractSignature"
      >
        {{ sending ? "Assinando..." : "Assinar contrato" }}
      </Button>
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted, ref, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router/composables';
import Button from '@/components/ui/AppButton.vue';
import Loader from '@/feature/minified-onboarding/components/Loader.vue';
import { useStore } from '@/utils/store';

export default defineComponent({
  name: 'ContractSignatureView',
  components: {
    Button,
    Loader,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const loading = ref(true);
    const sending = ref();

    const nextRoute = computed(
      () => store?.getters['minifiedOnboarding/nextRoute'],
    );

    async function goToContractSignature() {
      try {
        sending.value = true;
        await store?.dispatch('minifiedOnboarding/sendContractConfirmation');
        sending.value = false;
        await router.replace({
          name: nextRoute.value,
          query: route.query,
        });
      } catch (error) {
        router.go(0);
        throw new Error(error);
      }
    }

    onMounted(async () => {
      const { userId, onboardingToken: token, onboardingId } = route.query;

      loading.value = true;
      await store?.dispatch('auth/setToken', { token });
      await store?.dispatch('minifiedOnboarding/getOnboarding', {
        userId,
        onboardingId,
      });
      loading.value = false;
    });

    return {
      goToContractSignature,
      loading,
      sending,
    };
  },
});
</script>

<style lang="scss" scoped>

p {
  margin-bottom: 16px;
}

.loadingContainer {
  display: flex;
  overflow: auto;
  padding: 1.5rem;
  width: 100%;
  gap: 1.5rem;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-color: #ffffff;
}
.container-contract {
  display: flex;
  overflow: auto;
  flex-direction: column;
  border-top: 4px solid #ED0059;
  min-height: 90%;
  height: 90%;
  height: -webkit-fill-available;
  background-color: #ffffff;
  overflow: hidden;

  .header-container {
    background-color: white;
    display: flex;
    align-items: flex-start;
    border-bottom: 1px solid #e2e8f0;
    padding: 1.125rem 0;

    .title {
      display: flex;
      gap: 0.25rem;
      align-items: center;
      padding: 0 1.125rem;
      font-size: 1.125rem;
      line-height: 1.75rem;
      font-weight: 700;
    }

    .subtitle {
      font-size: 1rem;
      line-height: 1.5rem;
      color: #64748b;
    }
  }

  .main-container {
    display: flex;
    flex-direction: column;
    padding: 1.25rem;
    height: 100%;
    gap: 0.75rem;
    overflow-x: scroll;
    font-size: 16px;
    line-height: 24px;

    .title {
      font-weight: 700;
      font-size: 1.25rem;
      line-height: 1.75rem;
    }

    .text {
      font-size: 1rem;
      line-height: 1.5rem;
    }
  }

  .button-container {
    display: flex;
    background-color: white;
    border-top: 1px solid #e2e8f0;
    flex-direction: column;
    padding: 1.25rem;
    align-items: center;

    .button {
      display: flex;
      align-items: center;
      background: #ed0059;
      font-weight: 600;
      color: #ffffff;
      border: none;
      justify-content: center;
      border-radius: 24px;
      width: 100%;
      height: 48px;
    }
  }
}
</style>
